import React from 'react';
import Link from '../net/link';

class SidebarLink extends React.Component {

  render() {
    let {showLink, link, title, date} = this.props;
    return (
    <>
            {showLink ? 
          <li key={link}>{date ? <div>{date}</div> : null }<Link to={link}>{title}</Link></li>
          : <li key={link}>{date ? <div>{date}</div> : null }{title}</li>
        }

    </>  
    )
  }

}
export default SidebarLink;